const datenschutzContent = {
  title: "Datenschutzerklärung",
  intro:
    "Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.",
  sections: [
    {
      heading: "1. Kontakt mit uns",
      text:
        "Wenn Sie per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen für sechs Monate gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.",
    },
    {
      heading: "2. Cookies",
      text:
        "Unsere Website verwendet sogenannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Sie können Ihren Browser so einrichten, dass Sie über das Setzen von Cookies informiert werden und diese nur im Einzelfall erlauben oder generell ausschließen.",
    },
    {
      heading: "3. Ihre Rechte",
      text:
        "Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit, Widerruf und Widerspruch zu (Art. 15–21 DSGVO). Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche in sonst einer Weise verletzt worden sind, können Sie sich bei der zuständigen Aufsichtsbehörde beschweren.",
    },
    {
      heading: "4. Verantwortliche Stelle",
      text: (
        <>
          Anglerverein &quot;Angelfreunde 1866&quot; e.V. Berlin<br />
          Hausburgstraße 13, 10249 Berlin<br />
          E-Mail:{" "}
          <a
            href="mailto:info@angelfreunde1866.de"
            className="text-sky-600 hover:text-sky-700"
          >
            info@angelfreunde1866.de
          </a>
        </>
      ),
    },
    {
      heading: "5. Rechtsgrundlagen der Verarbeitung",
      text:
        "Die Verarbeitung Ihrer Daten erfolgt auf Basis Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO) oder auf Grundlage unseres berechtigten Interesses an der sicheren und effizienten Bereitstellung unseres Online-Angebots (Art. 6 Abs. 1 lit. f DSGVO).",
    },
    {
      heading: "6. Verwendung von Analysetools",
      text:
        "Unsere Website verwendet derzeit keine externen Analysetools (z. B. Google Analytics). Sollte dies zukünftig geändert werden, informieren wir Sie an dieser Stelle ausführlich über den Zweck, die Funktionsweise und Ihre Widerspruchsmöglichkeiten.",
    },
    {
      heading: "7. Weitergabe von Daten an Dritte",
      text:
        "Wir geben Ihre personenbezogenen Daten nur dann an Dritte weiter, wenn dies zur Vertragserfüllung erforderlich ist, Sie ausdrücklich eingewilligt haben oder eine gesetzliche Verpflichtung dazu besteht.",
    },
    {
      heading: "8. Sicherheitsmaßnahmen",
      text:
        "Wir treffen technische und organisatorische Sicherheitsmaßnahmen, um Ihre personenbezogenen Daten vor Verlust, Manipulation, Zerstörung oder unbefugtem Zugriff zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.",
    },
    {
      heading: "9. Speicherdauer",
      text:
        "Wir speichern Ihre personenbezogenen Daten nur so lange, wie dies für die Erfüllung der genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen. Nach Ablauf dieser Fristen werden die Daten gelöscht oder anonymisiert.",
    },
    {
      heading: "10. Hosting",
      text:
        "Unsere Website wird bei der IONOS SE (Elgendorfer Str. 57, 56410 Montabaur, Deutschland) gehostet. Beim Zugriff auf unsere Website werden durch IONOS automatisch sogenannte Server-Logfiles erfasst. Diese beinhalten: IP-Adresse des Besuchers (in anonymisierter Form), Datum und Uhrzeit des Zugriffs, aufgerufene Seite, übertragene Datenmenge, Browsertyp und Betriebssystem. Die Erfassung dieser Daten erfolgt zur Sicherstellung des störungsfreien Betriebs und zur Gefahrenabwehr. Die Daten werden nach spätestens 8 Tagen gelöscht und nicht mit anderen Datenquellen zusammengeführt. Weitere Informationen finden Sie in der Datenschutzerklärung von IONOS: https://www.ionos.de/terms-gtc/datenschutzerklaerung.",
    },
  ],
  lastUpdated: "Letzte Aktualisierung: Oktober 2025",
};

export default datenschutzContent;
